import { StyleSheet } from 'aphrodite/no-important';
import { colour } from '../style/base-theme';

export const styles = StyleSheet.create({
  endWrapper: {
    display: 'flex',
    position: 'relative',
    alignItems: 'flex-start',
    justifyContent: 'center',
    paddingTop: 20,
    paddingBottom: 15
  },
  rightSide: {
    flex: 4,
    textAlign: 'center',
    color: colour.grey[400],
    fontSize: 16
  }
});
